<template>
  <div class="app-footer__phone">
    <div class="app-footer__title">
      Telefonische Erreichbarkeit
    </div>
    <table>
      <tr>
        <td>
          Mo. - Do.
        </td>
        <td>
          09:00 - 18:00 Uhr
        </td>
      </tr>
      <tr>
        <td>
          Freitag
        </td>
        <td>
          09:00 - 15:00 Uhr
        </td>
      </tr>
    </table>
  </div>
</template>

<script setup lang="ts"></script>
